export default __webpack_public_path__ + "static/media/LOGOS_RGB-03.f1e3be18.png";